// @flow

import { Hide } from '@gandi/ui';

import PreferencesWidget from '../PreferencesWidget/PreferencesWidget';
import type { DialogState } from '../PreferencesWidget/types';
import UserWidget from '../UserWidget/UserWidget';

type Props = {
  preferencesDialog: DialogState,
  /** The Cart widget */
  widgets: React.Node,
};

// Show in the shopping pages
export function LandingPagesWidgets({
  preferencesDialog,
  widgets,
}: Props): React.MixedElement {
  return (
    <>
      <Hide until="sm">
        {/* Needed for Hide */}
        <div>
          <PreferencesWidget dialog={preferencesDialog} />
        </div>

        <UserWidget />
      </Hide>
      <div>{widgets}</div>
    </>
  );
}
